import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import type { RootState } from '@root/store/store';
import type { Bet } from '@root/store/types';

export const BET_SLICE_KEY = 'bet';

export interface BetSliceState {
  bets: Bet[];
  numberOfBets: number;
  notifiedBetsSuccess: string[];
  notifiedBetsError: string[];
}

const initialState: BetSliceState = {
  bets: [],
  numberOfBets: 0,
  notifiedBetsSuccess: [],
  notifiedBetsError: [],
};

const betSlice = createSlice({
  name: BET_SLICE_KEY,
  initialState,
  reducers: {
    setBets: (state, action: PayloadAction<Bet[]>) => {
      state.bets = [
        ...state.bets.filter(
          (bet) => !action.payload.some((newBet) => newBet.id === bet.id)
        ),
        ...action.payload,
      ];
    },
    setNumberOfBets: (state, action: PayloadAction<number>) => {
      state.numberOfBets = action.payload;
    },
    betNotifiedSuccess: (state, action: PayloadAction<string>) => {
      state.notifiedBetsSuccess = [
        ...state.notifiedBetsSuccess,
        action.payload,
      ];
    },
    betNotifiedError: (state, action: PayloadAction<string>) => {
      state.notifiedBetsError = [...state.notifiedBetsError, action.payload];
    },
    resetBetSlice: () => initialState,
  },
});

const betReducer = betSlice.reducer as Reducer;

export default betReducer;

export const betSelector = (state: RootState): BetSliceState => state.bet;

export const betActions = betSlice.actions;
